import { render } from "./HeroBadge.vue?vue&type=template&id=0e880ded&scoped=true"
import script from "./HeroBadge.vue?vue&type=script&lang=js"
export * from "./HeroBadge.vue?vue&type=script&lang=js"

import "./HeroBadge.vue?vue&type=style&index=0&id=0e880ded&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e880ded"]])

export default __exports__